<template>
    <!-- 右边主体[[ -->
    <div class="g-content personal">
        <div class="affiche-detail g-autofixheight">
            <h5 class="affiche-tit">{{detail.title}}</h5>
            <!-- 系统公告 start -->
            <div class="system-bulletin">
                <div class="detail-tit">
                    <router-link class="detail-tit-con" :to="{name: 'v4-personal-personal'}">个人中心</router-link>
                    <span class="f-inlineblock-top">/</span>
                    <!-- <a class="detail-tit-con" href="personal_center_more.html">系统公告</a> -->
                    <!-- <span class="f-inlineblock-top">/</span> -->
                    <p class="detail-tit-text f-inlineblock-top">公告</p>
                </div>
                <div class="detail-con" v-html="detail.content">
                </div>
            </div>			
            <!-- 系统公告 end -->
        </div>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/personal/personal.scss';
</style>
<style>
.personal .detail-con img{
    max-width: 100%;
}
</style>

<script>  
import {
    AnnounceDetail 
} from 'Services/getData.js';
export default {
    data() {
        return {
            detail: {}
        }
    },
    mounted(){
        this.getDetail();
    },
    methods: {
        async getDetail(){
            let res = await AnnounceDetail({
                id: this.$route.params.id
            });
            if(res.data.code == 0){
                this.detail = res.data.data;
            }
        }
    }
}
</script>